module.exports = __webpack_public_path__ + "img/amex.f84ee768.png";